import styles from "./questionText.module.scss";

export const QuestionText = (props: Props) => {
  return <p className={styles["ocrText"]}>{props.questionText}</p>;
};

interface Props {
  questionText: string;
}
